// TODO, OpenWeatherMap, API KEY: ce4b3984701d09216506bd194402483c

/**
 * Requires
 */

import $ from 'jquery'

window.jQuery = $

/**
 * Modules
 */
import * as ResetLocalStorage from './reset-local-storage'
import * as Lazyload from './lazyload'
import * as Parallax from './parallax'
import * as Masonry from './masonry'
import * as TheFeed from './the-feed'
import * as BlockText from './block-text'
import * as Activities from './activities'
import * as ExternalLinks from './external-links'
import * as Carousel from './carousel'
import * as HeaderSlides from './header-slides'
import * as HtmlEmbeds from './html-embeds'
import * as ScrollReveal from './scroll-reveal'
import * as MobileTables from './mobile-tables'
import * as Menu from './menu'
import * as SearchForm from './search-form'
import * as HutchiesDates from './hutchies-dates'
import * as PageNav from './page-nav'
import * as VideoEmbed from './video-embed'
import * as AjaxForms from './ajax-forms'
import * as HistoryPushState from './history-push-state'
import * as MultiDropdown from './multi-dropdown'
import * as HeaderActions from './header-actions'
import * as ItemLimiter from './item-limiter'
import * as AutoSubmit from './auto-submit'
import * as PageHeaderSpacer from './page-header-spacer'
import * as TableSorter from './table-sorter'
import * as TableFilter from './table-filter'
import * as WeatherOverview from './weather-overview'
import * as HeaderItems from './header-items'
import * as ProductOverrides from './product-overrides'
import * as ShopHistory from './shop-history'
import * as Toggle from './toggle'
import * as PageAnchor from './page-load-anchor'
import * as TextAutoColor from './text-auto-color'
import * as Popover from './popover'
import * as ProductGallery from './product-gallery'

ResetLocalStorage.init()
Lazyload.init()
Parallax.init()
Masonry.init()
TheFeed.init()
BlockText.init()
Activities.init()
ExternalLinks.init()
Carousel.init()
HeaderSlides.init()
HtmlEmbeds.initialise()
ScrollReveal.init()
MobileTables.init()
// Menu.init();
SearchForm.init()
HutchiesDates.init()
PageNav.init()
VideoEmbed.initialise()
AjaxForms.initialise()
HistoryPushState.initialise()
MultiDropdown.initialise()
HeaderActions.init()
ItemLimiter.initialise()
AutoSubmit.initialise()
PageHeaderSpacer.initialise()
TableSorter.initialise()
TableFilter.initialise()
WeatherOverview.init()
HeaderItems.init()
ProductOverrides.init()
ShopHistory.init()
Toggle.init()
PageAnchor.init()
TextAutoColor.init()
Popover.init()
ProductGallery.init()

/**
 * Initialise content after page has already loaded.
 * Used by Form.js
 *
 * @param  {HTMLDivElement} element   The container div
 * @return {void}
 */
window.main = {
  initialiseAfterLoad: (element) => {
    Lazyload.revalidate()
    Carousel.init()
  },
}

$(document).on('ajax.replace', (event) => {
  window.main.initialiseAfterLoad(event.currentTarget)
})
